export default "__VITE_ASSET__B$iPUUk3__"